import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

// RaceNotFound component to display when a track or race doesn't exist
const RaceNotFound = ({ onNextToJump }) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-sm">
        <AlertTriangle className="w-16 h-16 text-orange-500 mb-4 mx-auto" />
        <h2 className="text-xl font-bold mb-3 text-gray-800">Race Not Found</h2>
        <p className="text-gray-600 mb-6">
          The race you're looking for doesn't exist or may not be available yet.
        </p>
        <button
          onClick={onNextToJump}
          className="w-full px-6 py-3 bg-[#F30099] text-white rounded-md hover:bg-pink-700 transition duration-200 font-medium"
          data-gtm-element-id="todays-tips_next-race_button-1"
        >
          Go to Next Race
        </button>
        <Link
          to="/todays-tips"
          className="block text-center w-full mt-3 text-gray-500 hover:text-[#F30099]"
          data-gtm-element-id="todays-tips_view-all_link-1"
        >
          View All Today's Tips
        </Link>
      </div>
    </div>
  );
};

export default RaceNotFound;
